//Importação React
import React from "react";
export default function Footer() {
  return (
    <>
      <footer class=" bg-white shadow px-6 py-5 ">
        <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
          <div class="sm:flex sm:items-center sm:justify-between">
            {/* <ul class="flex flex-wrap items-center text-sm text-zinc-500 sm:mb-0 ">
              <li>
                <a href="#" class="mr-4 hover:underline md:mr-6 ">
                  Ajuda
                </a>
              </li>
              <li>
                <a href="#" class="mr-4 hover:underline md:mr-6">
                  Fale Conosco
                </a>
              </li>
              <li>
                <a href="#" class="mr-4 hover:underline md:mr-6 ">
                  Segurança
                </a>
              </li>
              <li>
                <a href="#" class="hover:underline">
                  Tarifas
                </a>
              </li>
            </ul> */}
          </div>
          <hr class="my-6 text-zinc-500 sm:mx-auto lg:my-8" />
          <span class="flex justify-end text-sm sm:text-center text-zinc-500">
            © 2023 Acesso Energia. Todos os direitos reservados | Privacidade
            Termos de uso
          </span>
        </div>
      </footer>
    </>
  );
}
